import { Icon } from "@ds/ds-snam/react";
import { useSelector } from "react-redux";
import { Tooltip } from 'react-tooltip';
import { DsLayout } from "shared/constants";
import { RootState } from "state/appStore";
import styles from "views/b2bView/components/calendarView/styles/calendarEventContent.module.css";

interface ITooltipIconProps {
    tooltipId:string,
    tooltipData:string
}
const TooltipIcon: React.FC<ITooltipIconProps> = (props): JSX.Element => {
    const {tooltipId,tooltipData} = props;
    const layoutMode = useSelector((state:RootState)=>{
      return state.dsLayout.mode;
  })
    return (
      <>
        <Icon
            iconSize="medium"
            icon="icon-info-circle"
            style={{ color: "var(--interaction-active)" }}
            id="tooltip-anchor-element-id"
            data-tooltip-id={tooltipId}
            data-tooltip-variant="light"
            data-tooltip-html={tooltipData}
        />

        <Tooltip
            id="calendar-event-tooltip"
            className={styles.calendarEventTooltip}
            border={"1px solid #6983af"}
            anchorSelect="#tooltip-anchor-element-id"
            style= {{background:layoutMode===DsLayout.DARK_MODE?"#04122a":"var(--background-2)",color:layoutMode===DsLayout.DARK_MODE?"white":"black",/*borderRadius:'12px'*/}}
        />
      </>
    )
}

export default TooltipIcon;